

























































import Vue from "vue";
import { Toast } from "vant";
Vue.use(Toast);
export default Vue.extend({
  data() {
    return {
      actuId: this.$route.query.actuId,
      info: {
        //基础数据
        periodNum: "",
        orderNum: "",
        startEndPeriodNum: "",
        bprice: "",
        joinActNum: ""
      }
    };
  },
  created() {
    this.getPageInfo();
    /**
     * 页面加载设置
     */
    this.$bridge.setBridgeIsShowInfo({
      close: "1",
      pull: "1",
      prev: "1",
      noback: "0",
      slip: "1",
      service: "0"
    });
  },
  methods: {
    //获取页面数据
    getPageInfo() {
      let _this = this;
      _this.$axios
        .post(
          "/wuAPI/fitDcApi/sptWxH5Jzy/trainActOrderReq",
          _this.$qs.stringify({
            "form.reqUid": _this.$F.userid(),
            "form.trainActId": _this.$route.query.trainid,
            "form.channel": "dc2",
            "form.state": 3,
            "form.procFlg": 1,
            "form.tactuId": _this.$route.query.tactuid,
            "form.actuId": _this.$route.query.actuId,
            "form.orderNum": _this.$route.query.orderid
          })
        )
        .then(res => {
          window.console.log(res);
          _this.info = res.data.entRet;
        })
        .catch(res => {
          Toast("页面加载失败");
        });
    },
    /**
     * 跳转开营倒计时
     */
    nextFn() {
      this.$openPage.NativeOpenPage("17");
    }
  }
});
